import { render, staticRenderFns } from "./quote-refer-info.vue?vue&type=template&id=0ca6f0b0&scoped=true&"
import script from "./quote-refer-info.vue?vue&type=script&lang=js&"
export * from "./quote-refer-info.vue?vue&type=script&lang=js&"
import style0 from "./quote-refer-info.vue?vue&type=style&index=0&id=0ca6f0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca6f0b0",
  null
  
)

export default component.exports